import React from 'react';
import { cn } from '../../utils/cn';

/**
 * StatusIndicator - Animated status indicator with ping effect
 *
 * @param {object} props - Component props
 * @param {string} props.status - Status text to display
 * @param {'success'|'warning'|'error'|'info'} [props.type='success'] - Status type
 * @param {string} [props.className=''] - Additional CSS classes
 */
const StatusIndicator = ({
  status,
  type = 'success',
  className = ''
}) => {
  // Color mapping for different status types
  const colors = {
    success: {
      ping: 'bg-emerald-400',
      dot: 'bg-emerald-500'
    },
    warning: {
      ping: 'bg-orange-400',
      dot: 'bg-orange-500'
    },
    error: {
      ping: 'bg-red-400',
      dot: 'bg-red-500'
    },
    info: {
      ping: 'bg-cyan-400',
      dot: 'bg-cyan-500'
    }
  };

  const currentColors = colors[type] || colors.success;

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="relative flex h-2 w-2">
        <span
          className={cn(
            'animate-ping absolute inline-flex h-full w-full rounded-full opacity-75',
            currentColors.ping
          )}
        ></span>
        <span
          className={cn(
            'relative inline-flex rounded-full h-2 w-2',
            currentColors.dot
          )}
        ></span>
      </span>
      <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
        {status}
      </span>
    </div>
  );
};

export default StatusIndicator;
